function gcd(a, b) {
  a = Math.abs(a)
  b = Math.abs(b)

  while (b) {
    ;[a, b] = [b, a % b]
  }
  return a
}

export function calculateRatioQuantity(numbers) {
  if (!Array.isArray(numbers)) {
    console.error('Input must be an array.')
    return []
  }
  if (numbers.length === 0) {
    return []
  }

  const validNumbers = numbers.filter(
    (num) => typeof num === 'number' && Number.isFinite(num)
  )

  if (validNumbers.length === 0) {
    console.warn('Input array contains no valid numbers.')
    return []
  }

  const allZeros = validNumbers.every((num) => num === 0)
  if (allZeros) {
    return numbers.map(() => 0)
  }

  let commonDivisor = validNumbers[0]
  if (commonDivisor === 0 && validNumbers.length > 1) {
    for (let i = 1; i < validNumbers.length; i++) {
      if (validNumbers[i] !== 0) {
        commonDivisor = validNumbers[i]
        break
      }
    }
    if (commonDivisor === 0) {
      return numbers.map(() => 0)
    }
  }

  for (let i = 1; i < validNumbers.length; i++) {
    commonDivisor = gcd(commonDivisor, validNumbers[i])
  }

  if (commonDivisor === 0) {
    return numbers.map(() => 0)
  }

  const ratioArray = numbers.map((num) => {
    if (typeof num !== 'number' || !Number.isFinite(num)) {
      return 0
    }
    return num / commonDivisor
  })

  return ratioArray
}
